import React from 'react';

// materiais

import matele from '../docs/materiais/material-fisica/Matemática_Para_Eletrostática.pdf';
import momli from '../docs/materiais/material-fisica/Momento_Linear.pdf';
import oncor from '../docs/materiais/material-fisica/Ondas_em_Cordas.pdf';
import propg from '../docs/materiais/material-fisica/Óptica_Geométrica.pdf';
import potele from '../docs/materiais/material-fisica/Potencial_Elétrico.pdf';
import matrel from '../docs/materiais/material-fisica/Materiais_Relatividade__Física___OB.pdf';
import matopt from '../docs/materiais/material-fisica/Coletânea_Óptica.pdf';
import cinema from '../docs/materiais/material-fisica/Aula2Cinemática.pdf';
import dinamica from '../docs/materiais/material-fisica/Aula3_Dinamica.pdf';
import movimentocircular from '../docs/materiais/material-fisica/Aula4_MovimentoCircular.pdf';
import momentoenergia from '../docs/materiais/material-fisica/Aula5_MomentoEEnergia.pdf';
import momentoangular from '../docs/materiais/material-fisica/MomentoAngular.pdf';

const Fisicamat = () => {
    return (
        <div>
            <h1 className="fontizzao">MATERIAIS - FÍSICA</h1>
            <hr className="line3"></hr>
            <center>
                <div className="text-container2">
                    <h4 className="corzaoo">
                        Para aprender os principais conteúdos que costumam aparecer em olimpíadas científicas e vestibulares, esta seção é o lugar ideal. Aqui, você encontrará materiais organizados para ajudar a fortalecer sua base de conhecimentos e desenvolver as habilidades necessárias para se destacar. Pronto(a) para alcançar novos patamares?
                    </h4>
                </div>
                <br />
            </center>
            <div className="fundo">
                <center>
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Momento Angular e Massa reduzida</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={momentoangular}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Aula 5 - Momento e Energia</h4>
                        <h4 className="cor">
                            Preparatório OBF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={momentoenergia}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Aula 4 - Movimento Circular</h4>
                        <h4 className="cor">
                            Preparatório OBF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={movimentocircular}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Aula 3 - Dinâmica</h4>
                        <h4 className="cor">
                            Preparatório OBF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={dinamica}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Aula 2 - Cinemática</h4>
                        <h4 className="cor">
                            Preparatório OBF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={cinema}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Coletânea de Óptica geométrica</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={matopt}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Introdução à Relatividade</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={matrel}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Matemática para Eletrostática</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={matele}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Momento Linear</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={momli}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Ondas em Cordas</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={oncor}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Potencial Elétrico</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={potele}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                    <div className="text-container3">
                        <h4 className="fontezao7cor">Princípios de óptica geométrica</h4>
                        <h4 className="cor">
                            OBF | ITA/IME | SOIF
                        </h4>
                    </div>
                    <div className="text-container4">
                        <a className="active" href={propg}>
                            <h4 className="cordiffff">Material</h4>
                        </a>
                    </div>
                    <br />
                </center>
            </div>
        </div>
    );
}

export default Fisicamat;
